export default __webpack_public_path__ + "static/media/mail.295759a3.svg";